import TemplateSection from "./TemplateSection.js";
import TemplateConfirm from "./TemplateConfirm.js";
import AddSection from "./AddSection.js";
import Dialog from "@material-ui/core/Dialog";
import Fab from "@material-ui/core/Fab";
import SwipeableViews from "react-swipeable-views";
import ButtonMenu from "../ButtonMenu";
import MenuItem from "@material-ui/core/MenuItem";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import TemplateSetup from "./TemplateSetup";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from "@material-ui/core/IconButton";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Popover from "@material-ui/core/Popover";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import BrushIcon from "@material-ui/icons/Brush";
import {
  setCustomFields,
  setTempId,
  whatsUsingThem,
} from "../../redux/actions/customFieldsActions";
import SectionGroup from "./SectionGroup";
import TextSection from "./TextSection";
import axios, { taxServiceClient, contentClient } from "../../AxiosClient";
import PubSub from "pubsub-js";
import { TEMPLATE_UPDATE, TEMPLATE_ADD } from "../../utils/Topics";
import { withStyles } from "@material-ui/core/styles";
import { withSnackbar } from "notistack";
import ColourPickerSingleDialog from "../dialog/ColourPickerSingleDialog";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";

const elementMappings = {
  Card,
  TextSection,
};

const styles = (theme) => ({
  section: {
    border: "1px dashed rgba(0, 0, 0, 0.4)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    margin: "8px",
  },
  formControl: {
    marginBottom: 5,
  },
});
export class CreateTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      template: {},
      left: [],
      middle: [],
      right: [],
      settings: { type: "cards", border: {} },
      addSectionOpen: false,
      selected: 0,
      tabsSelected: 0,
      edit: false,
      instance: "",
      createButtonDisabled: false,
      templateSetupOpen: false,
      templateSetupOpen: false,
      templateConfirmOpen: false,
      teams: [],
      sectionPosition: "",
      popoverAnchorEl: null,
      changeColoursDialogOpen: false,
    };
    this.saveTemplate = this.saveTemplate.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.template !== this.props.template) {
      this.setupTemplate();
    }
  }
  componentDidMount() {
    this.props.whatsUsingThem("template");
    if (this.props.template && this.props.editTemplate) {
      this.setupTemplate();
    }
    this.getTeams();
  }
  componentWillUnmount() {
    this.props.setCustomFields([]);
    this.props.whatsUsingThem("");
  }

  setupTemplate = () => {
    if (this.props.template.layoutData) {
      this.setState({ settings: JSON.parse(this.props.template.layoutData) });
    }
    this.setState({ template: this.props.template });
    let middle = [];
    let left = [];
    let right = [];
    for (let i = 0; i < this.props.template.templateSections.length; i++) {
      let section = Object.assign(this.props.template.templateSections[i]);
      // section.tempId = new Date().getTime().toString();
      section.tempId = Math.random();
      if (!section.deleted) {
        if (section.sectionColumn === "middle") {
          middle.push(section);
        } else if (section.sectionColumn === "left") {
          left.push(section);
        } else if (section.sectionColumn === "right") {
          right.push(section);
        }
      }
    }
    this.setState({ left: left, right: right, middle: middle });
    if (this.props.editTemplate) {
      this.ifTemplate();
    }
  };
  fixSortOrder = (array) => {
    return array.map((section, idx) => {
      return { ...section, sortOrder: idx };
    });
  };
  deleteSection = (section) => {
    if (section.sectionColumn === "left") {
      let left = this.state.left.splice(0);
      left.splice(section.sortOrder, 1);
      left = left.map((section, index) => ({ ...section, sortOrder: index }));
      this.setState({ left: left });
    } else if (section.sectionColumn === "middle") {
      let middle = this.state.middle.splice(0);
      middle.splice(section.sortOrder, 1);
      middle = middle.map((section, index) => ({
        ...section,
        sortOrder: index,
      }));
      this.setState({ middle: middle });
    } else if (section.sectionColumn === "right") {
      let right = this.state.right.splice(0);
      right.splice(section.sortOrder, 1);
      right = right.map((section, index) => ({ ...section, sortOrder: index }));
      this.setState({ right: right });
    }
    
    if(section.reusableSectionId && section.customFieldsRVOs){
      let clone = [];
      this.props.currentCustomFields.forEach(cf=>{
        let result = section.customFieldsRVOs.find((rvo) => rvo.id == cf.id);
        if(!result){
          clone.push(cf);
        }
      });
      this.props.setCustomFields(clone);
    }
  };
  editSection = (section) => {
    if (section.sectionColumn === "left") {
      let left = [...this.state.left];
      let r = 0;
      for (r; r < left.length; r++) {
        if (left[r].tempId === section.tempId) {
          left[r] = section;
        }
      }
      this.setState({ left });
    } else if (section.sectionColumn === "middle") {
      let middle = [...this.state.middle];
      let p = 0;
      for (p; p < middle.length; p++) {
        if (middle[p].tempId === section.tempId) {
          middle[p] = section;
        }
      }
      this.setState({ middle });
    } else if (section.sectionColumn === "right") {
      let right = [...this.state.right];
      let t = 0;
      for (let t = 0; t < right.length; t++) {
        if (right[t].tempId === section.tempId) {
          right[t] = section;
        }
      }
      this.setState({ right });
    }
  };
  render() {
    const { classes, t } = this.props;
    let styleBorder = { margin: "8px" };
    this.state.settings.type === "borders"
      ? (styleBorder = {
          borderColor: this.state.settings.border.colour,
          borderStyle: this.state.settings.border.style,
          borderWidth: this.state.settings.border.width,
          margin: "8px",
        })
      : (styleBorder = { margin: "8px" });
    return (
      <div
        style={{
          overflow: "auto",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
        }}
      >
        <CardContent style={{ flex: 1, display: "flex" }}>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <Typography variant="h5">
                  {this.props.editTemplate ? (
                    <Trans i18nKey="edit_template_header" />
                  ) : (
                    <Trans i18nKey="new_template_header" />
                  )}
                </Typography>
                <Typography variant="body2">
                  {this.props.editTemplate ? (
                    <Trans i18nKey="edit_template_subheader" />
                  ) : (
                    <Trans i18nKey="new_template_subheader" />
                  )}
                </Typography>
              </div>
              <div style={{ display: "flex" }}>
                <FormLabel>
                  <Trans i18nKey="template_setup_sections_type" />
                  <RadioGroup
                    row
                    onChange={(e, val) =>
                      this.setState({
                        settings: { ...this.state.settings, type: val },
                      })
                    }
                    id="position"
                    value={this.state.settings.type}
                  >
                    <FormControlLabel
                      value="cards"
                      control={<Radio />}
                      label={t("template_setup_page_cards")}
                    />
                    <FormControlLabel
                      value="tabs"
                      control={<Radio />}
                      label={t("template_setup_page_tabs")}
                    />
                    <FormControlLabel
                      value="borders"
                      control={<Radio />}
                      label={t("template_setup_page_borders")}
                    />
                    <FormControlLabel
                      value="none"
                      control={<Radio />}
                      label={t("template_setup_border_none")}
                    />
                  </RadioGroup>
                </FormLabel>
                {this.state.settings.type === "borders" && (
                  <>
                    <Tooltip title="Border styling">
                      <IconButton
                        aria-label="Edit borders button"
                        size="small"
                        onClick={(e) =>
                          this.setState({ popoverAnchorEl: e.currentTarget })
                        }
                      >
                        <BrushIcon />
                      </IconButton>
                    </Tooltip>
                    <Popover
                      anchorEl={this.state.popoverAnchorEl}
                      open={Boolean(this.state.popoverAnchorEl)}
                      onClose={() => this.setState({ popoverAnchorEl: null })}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      <div
                        style={{
                          flexDirection: "column",
                          display: "flex",
                          flex: 1,
                          padding: 15,
                          minWidth: 150,
                        }}
                      >
                        <Typography variant="h6" style={{ marginBottom: 10 }}>
                          Border styling
                        </Typography>
                        <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="age-label-placeholder">
                            <Trans i18nKey="template_setup_border_style" />
                          </InputLabel>
                          <Select
                            value={this.state.settings.border.style}
                            onChange={this.changeBorderStyle}
                            aria-label="Border style"
                            input={
                              <Input
                                name="classification"
                                id="age-label-placeholder"
                              />
                            }
                            name="age"
                          >
                            <MenuItem value={"none"}>
                              <Trans i18nKey="template_setup_border_none" />
                            </MenuItem>
                            <MenuItem value={"dotted"} arial-label="Dotted">
                              <Trans i18nKey="template_setup_border_dotted" />
                            </MenuItem>
                            <MenuItem value={"solid"}>
                              <Trans i18nKey="template_setup_border_solid" />
                            </MenuItem>
                            <MenuItem value={"dashed"}>
                              <Trans i18nKey="template_setup_border_dashed" />
                            </MenuItem>
                            <MenuItem value={"double"}>
                              <Trans i18nKey="template_setup_border_double" />
                            </MenuItem>
                            <MenuItem value={"groove"}>
                              <Trans i18nKey="template_setup_border_groove" />
                            </MenuItem>
                            <MenuItem value={"ridge"}>
                              <Trans i18nKey="template_setup_border_ridge" />
                            </MenuItem>
                            <MenuItem value={"inset"}>
                              <Trans i18nKey="template_setup_border_inset" />
                            </MenuItem>
                            <MenuItem value={"outset"}>
                              <Trans i18nKey="template_setup_border_outset" />
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="age-label-placeholder">
                            Border colour
                          </InputLabel>
                          <Select
                            open={false}
                            value={this.state.settings.border.colour}
                            onChange={this.changeBorderStyle}
                            onClick={this.openColourPicker}
                            aria-label="Border colour"
                            input={
                              <Input
                                name="classification"
                                id="age-label-placeholder"
                              />
                            }
                            name="age"
                          >
                            <MenuItem value={this.state.settings.border.colour}>
                              {this.state.settings.border.colour}
                            </MenuItem>
                          </Select>
                          <ColourPickerSingleDialog
                            open={this.state.changeColoursDialogOpen}
                            onClose={() =>
                              this.setState({ changeColoursDialogOpen: false })
                            }
                            onSubmit={this.changeBorderColour}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="age-label-placeholder">
                            Border width
                          </InputLabel>
                          <Select
                            value={this.state.settings.border.width}
                            onChange={this.changeBorderWidth}
                            input={
                              <Input
                                name="classification"
                                id="age-label-placeholder"
                              />
                            }
                            aria-label="Border width"
                            name="age"
                          >
                            <MenuItem value={"1px"}>
                              <Trans i18nKey="template_setup_border_width_very_thin" />
                            </MenuItem>
                            <MenuItem value={"2px"} aria-label="2px">
                              <Trans i18nKey="template_setup_border_width_thin" />
                            </MenuItem>
                            <MenuItem value={"4px"}>
                              <Trans i18nKey="template_setup_border_width_medium" />
                            </MenuItem>
                            <MenuItem value={"8px"}>
                              <Trans i18nKey="template_setup_border_width_thick" />
                            </MenuItem>
                            <MenuItem value={"16px"}>
                              <Trans i18nKey="template_setup_border_width_very_thick" />
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="age-label-placeholder">
                            Border margin
                          </InputLabel>
                          <Select
                            value={this.state.settings.border.margin}
                            onChange={this.changeBorderMargin}
                            input={
                              <Input
                                name="classification"
                                id="age-label-placeholder"
                              />
                            }
                            name="age"
                            aria-label="Border margin"
                          >
                            <MenuItem value={"2px"}>
                              <Trans i18nKey="template_setup_border_width_thin" />
                            </MenuItem>
                            <MenuItem value={"4px"} aria-label="4px">
                              <Trans i18nKey="template_setup_border_width_medium" />
                            </MenuItem>
                            <MenuItem value={"8px"}>
                              <Trans i18nKey="template_setup_border_width_thick" />
                            </MenuItem>
                            <MenuItem value={"16px"}>
                              <Trans i18nKey="template_setup_border_width_very_thick" />
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </Popover>
                  </>
                )}
              </div>
            </div>
            <DragDropContext onDragEnd={this.onSectionDragEnd}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                <Droppable droppableId="droppableLeft" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      style={{
                        flex: 0.25,
                      }}
                      aria-label="Left droppable section"
                      className={classes.section}
                      ref={provided.innerRef}
                      innerRef={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {this.state.left.map((section, idx) => {
                        return (
                          <Draggable
                            draggableId={
                              section.id ? section.id : section.tempId
                            }
                            index={idx}
                            key={
                              section.sectionID
                                ? section.sectionID
                                : section.tempId
                            }
                          >
                            {(dragProvided, dragSnapshot) => (
                              <Card
                                style={{ margin: "8px" }}
                                idx={idx}
                                key={idx}
                                isDragging={dragSnapshot.isDragging}
                                ref={dragProvided.innerRef}
                                innerRef={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                              >
                                <TemplateSection
                                  key={idx}
                                  idx={idx}
                                  editSection={this.editSection}
                                  deleteSection={this.deleteSection}
                                  section={section}
                                />
                              </Card>
                              // <TemplateSection
                              //   {...this.props}
                              //   isDragging={dragSnapshot.isDragging}
                              //   ref={dragProvided.innerRef}
                              //   innerRef={dragProvided.innerRef}
                              //   {...dragProvided.draggableProps}
                              //   {...dragProvided.dragHandleProps}
                              //   key={idx}
                              //   editSection={this.editSection}
                              //   deleteSection={this.deleteSection}
                              //   idx={idx}
                              //   section={section}
                              // />
                            )}
                          </Draggable>
                        );
                      })}
                      <div style={{ textAlign: "center", margin: 15 }}>
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          onClick={() => this.openSectionDialog("left")}
                        >
                          <Trans i18nKey="new_template_new_section_button" />
                        </Button>
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <Droppable droppableId="droppableMiddle" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      moveCard={(idx) => this.moveCard(idx, "middle")}
                      style={{
                        flex: 0.5,
                      }}
                      className={classes.section}
                      ref={provided.innerRef}
                      innerRef={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {this.state.settings.type === "cards" &&
                        this.state.middle.map((section, idx) => {
                          return (
                            <Draggable
                              draggableId={
                                section.id ? section.id : section.tempId
                              }
                              index={idx}
                              key={
                                section.sectionID
                                  ? section.sectionID
                                  : section.tempId
                              }
                              // aria-label="Draggable template section"
                            >
                              {(dragProvided, dragSnapshot) => (
                                <Card
                                  aria-label="Draggable template section"
                                  style={{ margin: "8px" }}
                                  idx={idx}
                                  key={idx}
                                  isDragging={dragSnapshot.isDragging}
                                  ref={dragProvided.innerRef}
                                  innerRef={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                  {...dragProvided.dragHandleProps}
                                >
                                  <TemplateSection
                                    key={idx}
                                    idx={idx}
                                    editSection={this.editSection}
                                    deleteSection={this.deleteSection}
                                    section={section}
                                  />
                                </Card>
                              )}
                            </Draggable>
                          );
                        })}
                      {this.state.settings.type === "tabs" && (
                        <div>
                          <Tabs
                            aria-label="Page title tabs"
                            value={this.state.tabsSelected}
                            onChange={this.changeTabSelected}
                          >
                            {this.state.middle.map((section, idx) => (
                              <Tab key={idx} label={section.name} />
                            ))}
                          </Tabs>
                          <SwipeableViews
                            style={{ width: "50%" }}
                            index={this.state.tabsSelected}
                            id="templatePages"
                          >
                            {this.state.middle.map((section, idx) => {
                              return (
                                <Draggable
                                  draggableId={
                                    section.id ? section.id : section.tempId
                                  }
                                  index={idx}
                                  key={
                                    section.sectionID
                                      ? section.sectionID
                                      : section.tempId
                                  }
                                >
                                  {(dragProvided, dragSnapshot) => (
                                    <TemplateSection
                                      key={idx}
                                      idx={idx}
                                      editSection={this.editSection}
                                      deleteSection={this.deleteSection}
                                      section={section}
                                      isDragging={dragSnapshot.isDragging}
                                      ref={dragProvided.innerRef}
                                      innerRef={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                    />
                                  )}
                                </Draggable>
                              );
                            })}
                          </SwipeableViews>
                        </div>
                      )}
                      {(this.state.settings.type === "borders" ||
                        this.state.settings.type === "none") &&
                        this.state.middle.map((section, idx) => {
                          return (
                            <Draggable
                              draggableId={
                                section.id ? section.id : section.tempId
                              }
                              index={idx}
                              key={
                                section.sectionID
                                  ? section.sectionID
                                  : section.tempId
                              }
                            >
                              {(dragProvided, dragSnapshot) => (
                                <div
                                  // aria-label="Bordered template section"
                                  // style={styleBorder}
                                  key={idx}
                                  idx={idx}
                                  isDragging={dragSnapshot.isDragging}
                                  ref={dragProvided.innerRef}
                                  innerRef={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                  {...dragProvided.dragHandleProps}
                                >
                                  <TemplateSection
                                    styling={styleBorder}
                                    // key={idx}
                                    // idx={idx}
                                    editSection={this.editSection}
                                    deleteSection={this.deleteSection}
                                    section={section}
                                    // isDragging={dragSnapshot.isDragging}
                                    // ref={dragProvided.innerRef}
                                    // innerRef={dragProvided.innerRef}
                                    // {...dragProvided.draggableProps}
                                    // {...dragProvided.dragHandleProps}
                                  />
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      <div style={{ textAlign: "center", margin: 15 }}>
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          onClick={() => this.openSectionDialog("middle")}
                          aria-label="New section"
                        >
                          <Trans i18nKey="new_template_new_section_button" />
                        </Button>
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <Droppable droppableId="droppableRight" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      style={{
                        flex: 0.25,
                      }}
                      className={classes.section}
                      ref={provided.innerRef}
                      innerRef={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {this.state.right.map((section, idx) => {
                        return (
                          <Draggable
                            draggableId={
                              section.id ? section.id : section.tempId
                            }
                            index={idx}
                            key={
                              section.sectionID
                                ? section.sectionID
                                : section.tempId
                            }
                          >
                            {(dragProvided, dragSnapshot) => (
                              <Card
                                style={{ margin: "8px" }}
                                idx={idx}
                                key={idx}
                                isDragging={dragSnapshot.isDragging}
                                ref={dragProvided.innerRef}
                                innerRef={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                              >
                                <TemplateSection
                                  key={idx}
                                  idx={idx}
                                  editSection={this.editSection}
                                  deleteSection={this.deleteSection}
                                  section={section}
                                />
                              </Card>

                              // <TemplateSection
                              //   isDragging={dragSnapshot.isDragging}
                              //   ref={dragProvided.innerRef}
                              //   innerRef={dragProvided.innerRef}
                              //   {...dragProvided.draggableProps}
                              //   {...dragProvided.dragHandleProps}
                              //   key={idx}
                              //   editSection={this.editSection}
                              //   deleteSection={this.deleteSection}
                              //   section={section}
                              // />
                            )}
                          </Draggable>
                        );
                      })}
                      <div style={{ textAlign: "center", margin: 15 }}>
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          onClick={() => this.openSectionDialog("right")}
                        >
                          <Trans i18nKey="new_template_new_section_button" />
                        </Button>
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
            <Fab
              onClick={() => this.setState({ templateConfirmOpen: true })}
              aria-label="Save template"
              style={{
                position: "absolute",
                bottom: 20,
                zIndex: 9999999999,
                marginLeft: "calc( 100% - (80px) )",
              }}
            >
              <SaveIcon />
            </Fab>
          </div>
        </CardContent>
        <Dialog
          open={this.state.addSectionOpen}
          fullWidth
          maxWidth="lg"
          disableEnforceFocus={true}
        >
          {this.state.addSectionOpen ? (
            <AddSection
              addSection={this.addSection}
              close={this.addSectionClosed}
              sectionColumn={this.state.sectionPosition}
            />
          ) : null}
        </Dialog>
        <Dialog open={this.state.templateSetupOpen}>
          {this.state.templateSetupOpen && (
            <TemplateSetup
              close={this.openTemplateSetup}
              settings={this.state.settings}
              setSettings={this.changeSettings}
              id="templateSetup"
            />
          )}
        </Dialog>
        <Dialog maxWidth={false} open={this.state.templateConfirmOpen}>
          {this.state.templateConfirmOpen ? (
            <TemplateConfirm
              template={this.props.template}
              close={this.changeTemplateConfirmOpen}
              saveTemplate={this.saveTemplate}
              teams={this.state.teams}
              updateTeams={this.updateTeams}
            />
          ) : null}
        </Dialog>
      </div>
    );
  }
  onSectionDragEnd = (one, two) => {
    let left = [...this.state.left];
    let right = [...this.state.right];
    let middle = [...this.state.middle];
    let section;

    if (one.source.droppableId === "droppableMiddle") {
      section = { ...middle[one.source.index] };
      middle.splice(one.source.index, 1);
    } else if (one.source.droppableId === "droppableLeft") {
      section = { ...left[one.source.index] };
      left.splice(one.source.index, 1);
    } else {
      section = { ...right[one.source.index] };
      right.splice(one.source.index, 1);
    }

    if (one.destination.droppableId === "droppableMiddle") {
      section.sectionColumn = "middle";
      middle.splice(one.destination.index, 0, section);
    } else if (one.destination.droppableId === "droppableLeft") {
      section.sectionColumn = "left";
      left.splice(one.destination.index, 0, section);
    } else {
      section.sectionColumn = "right";
      right.splice(one.destination.index, 0, section);
    }
    left = left.map((section, index) => ({ ...section, sortOrder: index }));
    right = right.map((section, index) => ({ ...section, sortOrder: index }));
    middle = middle.map((section, index) => ({ ...section, sortOrder: index }));
    this.setState({ left, middle, right });
  };
  goHome = () => {
    this.props.setCustomFields([]);
    this.props.goHome();
  };

  openColourPicker = () => {
    this.setState({
      changeColoursDialogOpen: !this.state.changeColoursDialogOpen,
    });
  };
  moveCard = (id, sideText) => {
    let side = null;
    if (sideText === "middle") {
      side = this.state.middle.splice(0);
    } else if (sideText === "right") {
      side = this.state.right.splice(0);
    } else {
      side = this.state.left.splice(0);
    }
    const card = side.filter((section) => section.sortOrder === id)[0];
    const index = side.indexOf(card);
    side.splice(index, 1);
    if (sideText === "middle") {
      this.setState({ middle: side });
    } else if (sideText === "right") {
      this.setState({ right: side });
    } else {
      this.setState({ left: side });
    }
  };
  hasSection = () => {
    if (
      this.state.left.length > 0 ||
      this.state.middle.length > 0 ||
      this.state.right.length > 0
    ) {
      this.setState({ createButtonDisabled: false });
    } else {
      this.setState({ createButtonDisabled: true });
    }
  };
  changeTabSelected = (event, value) => {
    this.setState({ tabsSelected: value });
  };
  changeTemplateConfirmOpen = () => {
    this.setState({ templateConfirmOpen: !this.state.templateConfirmOpen });
  };

  changeBorderColour = (value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, colour: value },
      },
      changeColoursDialogOpen: false,
    });
  };

  changeBorderStyle = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, style: event.target.value },
      },
    });
  };
  changeBorderWidth = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, width: event.target.value },
      },
    });
  };
  changeBorderMargin = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, margin: event.target.value },
      },
    });
  };
  addToSectionArray = (section) => {
    if (section.sectionColumn == "middle") {
      let middle = this.state.middle.splice(0);
      section.sortOrder = middle.length;
      middle.push(section);
      middle = this.fixSortOrder(middle);
      this.setState({ middle: middle });
    } else if (section.sectionColumn == "left") {
      let left = this.state.left.splice(0);
      section.sortOrder = left.length;
      left.push(section);
      left = this.fixSortOrder(left);
      this.setState({ left: left });
    } else if (section.sectionColumn == "right") {
      let right = this.state.right.splice(0);
      section.sortOrder = right.length;
      right.push(section);
      right = this.fixSortOrder(right);
      this.setState({ right: right });
    }
  };
  addSection = (section) => {
    section.tempId = new Date().getTime().toString();
    this.addToSectionArray(section);
    this.setState({ addSectionOpen: false, sectionPosition: "" });
  };
  openTemplateSetup = () => {
    this.setState({ templateSetupOpen: !this.state.templateSetupOpen });
  };
  changeSettings = (settings) => {
    this.setState({ settings: settings });
    if (settings.type == "borders") {
      this.setState({
        borderStyling: {
          colour: settings.border.colour,
          style: settings.border.style,
          margin: settings.border.margin,
          width: settings.border.width,
        },
      });
    } else if (settings.type == "none") {
      this.setState({
        borderStyling: { colour: null, style: null, margin: null, width: null },
      });
    }
    this.openTemplateSetup();
  };
  openSectionDialog = (sectionPosition) => {
    this.setState({ addSectionOpen: true, sectionPosition });
  };
  addSectionClosed = () => {
    this.setState({ addSectionOpen: false, sectionPosition: "" });
  };
  saveTemplate = (template) => {
    let templateRVO = template;
    let sections = this.state.left.concat(this.state.middle);
    sections = sections.concat(this.state.right);
    if (sections.length != 0) {
      sections.map((sec) => {
        sec.deleted = false;
      });
    }
    if (containsScriptOrSVG(sections.map(section=> section.defaultText))) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter(sections.map(section=> section.defaultText))) {
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }    
    templateRVO.templateSections = sections;
    let teamIds = [];
    templateRVO.teamNames.map((team) => teamIds.push(team.teamId));
    templateRVO.teamIds = teamIds;
    let customFields = this.props.currentCustomFields;
    let newCustomFields = [];
    for (let i = 0; i < customFields.length; i++) {
      customFields[i].displayOrder = i;
      newCustomFields.push(customFields[i]);
    }
    templateRVO.customFields = newCustomFields;
    templateRVO.layoutData = JSON.stringify(this.state.settings);
   // templateRVO.templateSections = templateRVO.templateSections;
    if (this.props.editTemplate) {
      contentClient
        .patch(`/template/${template.id}`, { ...templateRVO })
        .then((res) => {
          this.props.onTemplateSave(res.data);
          PubSub.publish(TEMPLATE_UPDATE, { template: res.data });
          this.props.enqueueSnackbar("Template updated successfully", {
            variant: "success",
          });
          this.setState({ templateConfirmOpen: false });
          this.props.goHome();
        })
        .catch((err) => {
          this.props.enqueueSnackbar(
            `An error occured: ${err.response.error}`,
            {
              variant: "error",
            }
          );
        });
    } else {
      contentClient
        .post("/template/", templateRVO)
        .then((res) => {
          // this.props.onTemplateSave(res.data);
          PubSub.publish(TEMPLATE_ADD, { template: res.data });
          this.props.enqueueSnackbar("Template saved successfully", {
            variant: "success",
          });
          this.setState({ templateConfirmOpen: false });
          this.props.goHome();
        })
        .catch((err) => {
          this.props.enqueueSnackbar(`An error occured: ${err}`, {
            variant: "error",
          });
        });
    }
  };

  getTeams = () => {
    taxServiceClient.get("/team/").then((res) => {
      this.setState({ teams: res.data.content });
    });
  };
  ifTemplate = () => {
    contentClient
      .get(`/template/${this.props.template.id}/customfield/`)
      .then((res) => {
        let currentCustomFields = res.data;
        let tempId = 0;
        for (let i = 0; i < currentCustomFields.length; i++) {
          // currentCustomFields[i].tempId = tempId;
          currentCustomFields[i].template = true;
          if (tempId < currentCustomFields[i].tempId) {
            tempId = currentCustomFields[i].tempId;
          }
        }
        this.props.setTempId(tempId);
        this.props.setCustomFields(currentCustomFields);
        if (this.props.customFieldsChange) {
          this.props.customFieldsChange(currentCustomFields);
        }
      });
  };
}
const mapDispatchToProps = {
  setCustomFields,
  setTempId,
  whatsUsingThem,
  setGlobalAlert,
};
const mapStateToProps = (state) => ({
  currentCustomFields: state.customFields.currentCustomFields,
  message: state.websocket.message,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(withSnackbar(CreateTemplate))));
